import {
  SnackbarOrigin,
  useSnackbar,
  VariantType,
  WithSnackbarProps,
} from "notistack";
import * as React from "react";

interface IProps {
  setUseSnackbarRef: (showSnackbar: WithSnackbarProps) => void;
}

const InnerSnackbarUtilsConfigurator: React.FC<IProps> = (props: IProps) => {
  props.setUseSnackbarRef(useSnackbar());
  return null;
};

let useSnackbarRef: WithSnackbarProps;
const setUseSnackbarRef = (useSnackbarRefProp: WithSnackbarProps) => {
  useSnackbarRef = useSnackbarRefProp;
};

export const SnackbarUtilsConfigurator = () => {
  return (
    <InnerSnackbarUtilsConfigurator setUseSnackbarRef={setUseSnackbarRef} />
  );
};

const SnackAlert = {
  success(msg: string) {
    this.toast(msg, "success", { horizontal: "right", vertical: "bottom" });
  },
  warning(msg: string) {
    this.toast(msg, "warning", { horizontal: "right", vertical: "bottom" });
  },
  info(msg: string) {
    this.toast(msg, "info", { horizontal: "right", vertical: "bottom" });
  },
  error(msg: string) {
    this.toast(msg, "error", { horizontal: "right", vertical: "bottom" });
  },
  close() {
    this.toast("", "error", { horizontal: "right", vertical: "bottom" }, true);
  },
  toast(
    msg: string,
    variant: VariantType = "default",
    anchorOrigin?: SnackbarOrigin,
    isCloseSnackBar?: boolean
  ) {
    if (msg) {
      useSnackbarRef.enqueueSnackbar(msg, {
        variant,
        anchorOrigin,
        autoHideDuration: 5000,
      });
    }
    if (isCloseSnackBar) {
      useSnackbarRef.closeSnackbar();
    }
  },
};

export default SnackAlert;
